export const DEFAULT_PACKING = [
  "🥾 Botas o tenis de senderismo (con suela antiderrapante)",
  "👕 Playera dryfit o deportiva que seque rápido",
  "🧥 Chamarra o abrigo por si hay baja temperatura",
  "🧤 Guantes",
  "🕶️ Lentes de sol con filtro UV400",
  "👖 Pantalón holgado o de senderismo (evita la mezclilla)",
  "🧴 Bloqueador solar",
  "🍫 Snacks para el camino (frutos secos, chocolates, galletas, sándwich)",
  "🍶 2 litros de agua o bebida hidratante",
  "💸 Dinero extra para gastos personales",
  "☔ Impermeable",
  "🔦 Lámpara frontal",
];

export const routeHref = (route) =>
  route?.slug ? `/${encodeURIComponent(route.slug)}` : `/tour/${route?.route_id || ""}`;

export const DEFAULT_PACKING_EN = [
  "🥾 Hiking boots or trail shoes (non-slip sole)",
  "👕 Dry-fit or quick-dry sports shirt",
  "🧥 Jacket or coat in case it gets cold",
  "🧤 Gloves",
  "🕶️ Sunglasses with UV400 filter",
  "👖 Loose or hiking pants (avoid denim)",
  "🧴 Sunscreen",
  "🍫 Snacks for the trail (nuts, chocolate, cookies, a sandwich)",
  "🍶 2 liters of water or a hydrating drink",
  "💸 Extra cash for personal expenses",
  "☔ Rain jacket",
  "🔦 Headlamp",
];


export const DIFFICULTY_STYLES = {
  familiar: "bg-[#EDE9FE] text-[#6D28D9]",
  principiante: "bg-[#E6F4EA] text-[#1E7E34]",
  intermedio: "bg-[#FEF3C7] text-[#B45309]",
  avanzado: "bg-[#FEE2E2] text-[#B91C1C]",
  muy_avanzado: "bg-[#16221D] text-[#F7F5F0]",
};

// Sirve una versión más ligera de la imagen (Unsplash y nuestro almacenamiento aceptan ancho por query).
export const thumb = (url, width = 640) => {
  if (!url) return url;
  if (url.includes("images.unsplash.com")) {
    const [base, query = ""] = url.split("?");
    const params = new URLSearchParams(query);
    params.set("w", String(width));
    params.set("q", "70");
    params.set("fm", "webp");
    params.set("auto", "format");
    return `${base}?${params.toString()}`;
  }
  if (url.includes("/api/files/")) return `${url}${url.includes("?") ? "&" : "?"}w=${width}`;
  return url;
};

// Juego de anchos para que el móvil descargue la versión pequeña y el escritorio la grande.
export const srcSet = (url, widths = [400, 640, 1024, 1280]) =>
  widths.map((w) => `${thumb(url, w)} ${w}w`).join(", ");

export const seatLabel = (code) => {
  if (!code) return "Sin lugar";
  const m = String(code).trim().match(/^([A-Za-z])(\d+)$/);
  if (!m) return code;
  const row = m[1].toUpperCase().charCodeAt(0) - 66; // B = fila 1
  if (row < 0) return code; // fila A = cabina (guías/chofer)
  return `Fila ${row + 1}, asiento ${m[2]}`;
};

export const money = (n) =>
  "$" + Number(n || 0).toLocaleString("es-MX", { maximumFractionDigits: 0 });

export const formatDate = (iso, lang) => {
  const d = new Date(iso + "T12:00:00");
  return d.toLocaleDateString(lang === "es" ? "es-MX" : "en-US", {
    weekday: "long", day: "numeric", month: "short",
  });
};

export const shortDate = (iso, lang) => {
  const d = new Date(iso + "T12:00:00");
  return d.toLocaleDateString(lang === "es" ? "es-MX" : "en-US", { day: "numeric", month: "short" });
};

export const weekdayDate = (iso, lang) => {
  const d = new Date(iso + "T12:00:00");
  return d.toLocaleDateString(lang === "es" ? "es-MX" : "en-US", {
    weekday: "long", day: "numeric", month: "long",
  });
};

export const depInfo = (dep, lang) => {
  const es = lang === "es";
  const departureDate = dep.departure_date || dep.date;
  const returnDate = dep.return_date || dep.date;
  const days = dep.days || 1;
  return {
    departureLabel: `${es ? "Salida" : "Departure"}: ${weekdayDate(departureDate, lang)} · ${dep.departure_time} hrs`,
    returnLabel: `${es ? "Regreso" : "Return"}: ${weekdayDate(returnDate, lang)} · ${dep.return_time} hrs (${es ? "aprox." : "approx."})`,
    departureShort: `${dep.departure_time} hrs ${es ? "del" : "of"} ${weekdayDate(departureDate, lang)}`,
    returnShort: `${dep.return_time} hrs ${es ? "del" : "of"} ${weekdayDate(returnDate, lang)}`,
    overnight: Boolean(dep.departs_previous_day),
    overnightNote: es
      ? `Salimos la noche anterior (${weekdayDate(departureDate, lang)} a las ${dep.departure_time} hrs)`
      : `We leave the night before (${weekdayDate(departureDate, lang)} at ${dep.departure_time} hrs)`,
    durationLabel: days > 1
      ? `${days} ${es ? "días de actividad" : "activity days"}`
      : es ? "1 día de actividad" : "1 activity day",
  };
};

export const googleCalendarUrl = ({ title, date, time = "07:00", days = 1, details = "", location = "" }) => {
  const start = new Date(`${date}T${time}:00`);
  const end = new Date(start.getTime() + (days > 1 ? days * 24 : 12) * 3600 * 1000);
  const fmt = (d) => d.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: title,
    dates: `${fmt(start)}/${fmt(end)}`,
    details,
    location,
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
};
